import { isStudioModuleEntitled, readAuthUser } from "./studioModules";

/** Partner network (designer ↔ production partners). Off unless the env flag is on. */
export const isPartnerNetworkEnabled = (): boolean =>
  process.env.REACT_APP_PARTNER_NETWORK_ENABLED === "true";

const isStudioAdmin = (role?: string): boolean =>
  role === "SUPER_ADMIN" || role === "ORGANIZATION_ADMIN" || role === "ORGANIZATION_MANAGER";

/**
 * Designer side: Partners page and Production board. Shown to studio admins when the flag is on; the
 * page itself explains the Network plan when the studio doesn't have it (the server enforces it).
 */
export const canUseProductionNetwork = (role?: string): boolean =>
  isPartnerNetworkEnabled() && isStudioAdmin(role);

export const hasNetworkPlan = (): boolean => isStudioModuleEntitled("NETWORK" as any);

/** Partner side: receiving orders is free for every studio. */
export const canReceivePartnerOrders = (role?: string): boolean =>
  isPartnerNetworkEnabled() && isStudioAdmin(role);

export const currentStudioName = (): string =>
  readAuthUser()?.users?.organizationResponse?.name || "your studio";
